module.exports = __webpack_public_path__ + "img/icon_home_ai_logo_2.e62f4ba7.gif";